import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bannerMessageTextClassName } from "../shared/typography-responsive";
import { cn } from "../utils";
import { errorBannerVariants } from "./error-banner.styles";
/**
 * ErrorBanner component - Displays error messages in a styled banner
 *
 * @example
 * ```tsx
 * <ErrorBanner message="We couldn't find an account with this information. Try again" />
 * ```
 */
export function ErrorBanner({ message, className, testID, }) {
    return (_jsxs("div", { className: cn(errorBannerVariants(), "bg-error-container rounded-2xl min-h-[40px] p-4", className), "data-testid": testID, children: [_jsx("div", { className: "flex-shrink-0 w-5 h-5", children: _jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", "aria-hidden": "true", children: [_jsx("circle", { cx: "10", cy: "10", r: "10", className: "fill-on-error-container" }), _jsx("path", { d: "M10 5V11", stroke: "white", strokeWidth: "2", strokeLinecap: "round" }), _jsx("circle", { cx: "10", cy: "14", r: "1", fill: "white" })] }) }), _jsx("span", { className: cn(bannerMessageTextClassName, "text-on-error-container"), children: message })] }));
}
//# sourceMappingURL=ErrorBanner.js.map